// eslint-disable-next-line no-restricted-imports
import { useTranslation as useI18nTranslation } from 'next-i18next';

const useTranslation = () => {
    const { t, ready, i18n: i18nInstance } = useI18nTranslation(['translations']);
    return {
        currentLanguage: i18nInstance.language,
        t: (ready
            ? (str: string, interpolations?: Record<string, any>) =>
                  /* i18next-extract-disable-next-line */
                  t(str || '', { ...interpolations }) as string
            : () => '') as typeof t,
        ready,
        i18n: i18nInstance
    };
};

export default useTranslation;
